import { LookupValue } from "../../../models/common/lookup-value";
import NamedContact from "../../../models/named-contact";

export class CBMemberData implements NamedContact {
  portrait: string;
  profileImagePath: string;
  firstName: string;
  lastName: string;
  prefix: string;
  suffix: string;
  id: number;
  status: string;
  isActive: boolean;
  riskLevel: number;
  gender: LookupValue;
}



// WEBPACK FOOTER //
// ./src/navigation/components/brief-bar/cb-member-data.ts